import { gqlTagSwag } from '@atlassian/jira-apollo-swag';

export const epicFragment = gqlTagSwag`
    fragment IssueParentFragment on IssueParent {
        id
        key
        summary
        issueType {
            id
            name
            iconUrl
        }
        color
        childrenInfo {
            todoStats {
                issueCount
            }
            inProgressStats {
                issueCount
            }
            doneStats {
                issueCount
            }
        }
        startDate
        dueDate
    }
`;

export const projectLocationFragment = gqlTagSwag`
    fragment ProjectLocationFragment on Project {
        id
        issueTypes {
            id
            name
            hierarchyLevelType
            iconUrl
            hasRequiredFields
        }
    }
`;

export const timeTrackingOptionsFragment = gqlTagSwag`
    fragment TimeTrackingOptionsFragment on TimeTrackingOptions {
        workingHoursPerDay
        workingDaysPerWeek
        defaultUnit
        timeFormat
    }
`;

export const epicLiteFragment = gqlTagSwag`
    fragment IssueParentLiteFragment on IssueParent {
        id
        key
        summary
        color
    }
`;

export const issueParentTypeConfigFragment = gqlTagSwag`
    fragment IssueParentTypeConfigFragment on IssueParentTypeConfig {
        id
        name
        iconUrl
        hierarchyLevelType
    }
`;

export const columnFragment = gqlTagSwag`
    fragment ColumnFragment on Column {
        isDone
        isInitial
    }
`;

export const boardFragment = gqlTagSwag`
    fragment BoardFragment on Board {
        rankCustomFieldId
    }
`;
